import { CanActivateFn, ActivatedRouteSnapshot } from '@angular/router';
import { inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { firstValueFrom } from 'rxjs';

import { SPORT_KEY_FOR_ROUTE } from '../app.utils';
import { environment } from '../../environments/environment';
import { Sport } from '../states/sport/sport.models';
import { FetchSportConfig, SetCurrentSport } from '../states/sport/sport.actions';
import { isSport } from '../states/sport/sport.utils';
import { FetchAuthentication, FetchAuthorization } from '../states/auth/auth.actions';

/**
 * Used to determine if the user is authenticated before granting them access to a route
 * @param route
 * @returns
 */
export const AuthGuard: CanActivateFn = async(route: ActivatedRouteSnapshot) => {
    const store = inject(Store);

    // get the sport parameter from the URL
    const sport = route.paramMap.get(SPORT_KEY_FOR_ROUTE);

    if (!sport || !isSport(sport)) {
        console.error('Sport parameter is missing from the route or it is not a valid sport');
        window.location.href = environment.loginUrl;
        return false;
    }

    // set the current sport from the URL so it's available to make the request for authorizations
    store.dispatch([
        new SetCurrentSport(sport as Sport),
        new FetchSportConfig()
    ]);

    try {
        await firstValueFrom(
            // fetch the authorization for this user, if this is successful it means they are authenticated
            store.dispatch([
                new FetchAuthorization(),
                new FetchAuthentication()
            ])
        );
        return true;

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (error) {
        // authorization call failed, the user is not authenticated
        // redirect the user to the login URL
        window.location.href = environment.loginUrl;

        // stop further navigation
        return false;
    }
};
